<template>
  <div>
    <el-select
      clearable
      v-model="IsPaid"
      placeholder="Ejecucion"
      @change="handlePaymentsPaidSelection"
      v-bind="$attrs"
      size="mini"
    >
      <!-- <el-option :key="0" :value="0" label="Todos"></el-option> -->
      <el-option
        v-for="item in PaymentsAndInvoicesPaidOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "PaymentAndInvoicePaid",

  data() {
    return {
      IsPaid: null,
      PaymentsAndInvoicesPaidOptions: [
        { value: true, label: "Ejecutado" },
        { value: false, label: "Sin Ejecutar" }
      ]
    };
  },

  mounted() {},

  methods: {
    handlePaymentsPaidSelection(executionSelected) {
      this.$emit("OnExecutionSelected", executionSelected);
    }
  }
};
</script>

<style scoped></style>
